import { defineStore, acceptHMRUpdate } from 'pinia';
import Cookies from 'js-cookie';
import { Session } from '@/utils/storage';

/**
 * 用户信息
 * @methods setUserInfos 设置用户信息
 */
export const useStore = defineStore('store', {
  state: () => {
    return {
      state: {
        app: {
          ip: '',
          bprod: false,
          device: '',
          entryurl: '',
          bmenuloaded: false,
          menudata: null as any,
          stomp: null as any,
          listenerSubs:new Map()
        },
        cfg:{
          capi: '',
          chost: '',
          cfile: '',
          cinfile: '',
          cimg: '',           
          ctitle: '',
          cname: '',      
          cclr:'#0c4c7d',  
          cclr1:'',
          cclr2:'',
          cfclr:'',
          ctopbarbc: '#0c4c7d',// 默认顶栏导航背景颜色      
          ctoptabbc: '#0c4c7d',// 默认顶栏导tab背景颜色
          ctopbarfc: '#f0f0f0',// 默认顶栏导航字体颜色 
          cmnubc:  '#0c4c7d',// 默认菜单导航背景颜色
          cmnufc: '#f0f0f0',// 默认菜单导航字体颜色
          cmnuac: '#86a6be',// 默认菜单高亮背景色
        },
        config: {
          ismobile: false,
          mobile: '',
          api: '',
          ws:'',
          host: '',
          file: '',
          infile: '',
          upfile: '',
          img: '',
          theme_img: '',
          title: '',
          name: '',
          login_name: '',
          bg_name: '',
          logo_name: '',
          lang: '',
          idappset: '',
          ccodefed: '',
          style: '',
          iconstyle: '',
          isshow_animation: true,
          isshow_particles: false,
          shapeType: '',
          particles_color: '',
          particles_linesColor: '',
          isshow_logo: false,
          icp: '',
          ip: '',
          layout:'',
          islayout:true,
          dyroute:true,
          operpath:true,
          crouter:'',
          head_bgc: '',
          head_c: '',
          ishnt:false,
          color:'#00AAB5',
          colormenu:'#30302C',
          colorbar:'#30302C',
          ismsn:false,
          istest:false
        },
        user: {
          id: '',
          ccode:'',
          cname: '',
          idtoken: '',
          idfed: '',
          cbarfed: '',
          ccodefed: '',
          cnamefed: '',
          iduser: '',
          ccodeuser: '',
          cnameuser: '',
          idorg: '',
          ccodeorg: '',
          idwfscheme: '',
          idwfdept: '',
          cbarwfdept: '',
          ccodewfdept: '',
          cnamewfdept: '',
          idwfjob: '',
          cnamewfjob: '',
          idwfpos: '',
          cnamewfpos: '',
          idfidept: '',
          cbardept: '',
          ccodedept: '',
          cnamefidept: '',
          cnameorg: '',
          iddept: '',
          cnamedept: '',
          idjob: '',
          cnamejob: '',
          idpos: '',
          ccodepos: '',
          cnamepos: '',
          idempl: '',
          cnameempl: '',
          idccy: '',
          cnameccy: '',
          ipdec: 6,
          imdec: 2,
          iqdec: 4,
          iqbdec: 3,
          iaccmode: 0,
          idcust: '',
          ccodecust: '',
          cnamecust: '',
          idowner: '',
          cnameowner: '',
          cnamerole: '',
          idlang: '',
          ccodelang: '',
          ddate: '',
          cip: '',
          idmaker: '',
          cmaker: '',
          iread: 999,
          iwrite: 999,
          message: 0,
          iloginph: 0,
          cphone: '',
          cpassword:'',
          ipwdtype: 0, //0:不检查密码格式 1-9:按规则检查密码格式，
          ipwdmin: 0,
          ipwdmax: 0,
          ipwderr: 0,
          ipwdlock: 0, // 0表示一直锁住
          ipwdavl: 180,
        },  
        msn: {
          userlst: [
            {
              id: '_system',
              cico: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202103%2F23%2F20210323142848_6a340.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1696689338&t=e7676eb9ff0380aa53e4d6046a29ae1f',
              cnick: '系统',
              ctalk: '',
              chatlst: [
                // {
                // 	id: Math.round(new Date().getTime() / 1000)
                // 		.toString()
                // 		.slice(4, 10),
                // 	dr: 0,
                // 	ddate: fomatTime(new Date(), 'hhmm'),
                // 	ctalk: 'hi',
                // },
              ],
            },
          ] as any[],
        },
        dc_clipdata:{
          type:'',
          data:null,
        }
      }
    }
  },
  getters: {
  },
  actions: {
    async setUser(user: any) {
      this.state.user = user;
    },
    getPathByName(name: string) {
      if (!this.state.app.menudata || !this.state.app.menudata.data || this.state.app.menudata.data.length === 0)
        return '';
      let menulst = this.state.app.menudata.data;
      for (let i1 = 0; i1 < menulst.length; i1++) {
        if (menulst[i1].name === name)
          return menulst[i1].path;
      }
    }
  }
});

